/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiRequestConfig, commonResource } from '@src/apis/helper/resource';

/* eslint-disable require-jsdoc */
export type RequestParam = unknown;

export type RequestConfig = ApiRequestConfig;

class Resource {
  post<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<T> {
    return commonResource.post(url, req, { ...config, baseURL: '/zgServer' });
  }

  postNoAuth<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<T> {
    return commonResource.postNoAuth(url, req, { ...config, baseURL: '/zgServer' });
  }

  postForm<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<T> {
    return commonResource.post(url, req, { ...config, baseURL: '/zgServer' });
  }

  get<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<any> {
    return Promise.resolve();
  }

  update<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<any> {
    return Promise.resolve();
  }

  delete<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<any> {
    return Promise.resolve();
  }

  put<T>(url: string, req: RequestParam, config?: RequestConfig): Promise<any> {
    return Promise.resolve();
  }
}

export const resource = new Resource();
